import { createFileRoute } from "@tanstack/react-router";

import { HostedAuth0Redirect } from "@/components/auth/HostedAuth0Redirect";
import { PRODUCT_NAME } from "@/lib/product";

export const Route = createFileRoute("/password-reset")({
  head: () => ({ meta: [{ title: `Reset password · ${PRODUCT_NAME}` }] }),
  component: PasswordResetPage,
});

function PasswordResetPage() {
  return <HostedAuth0Redirect />;
}
